var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1kzPNdUsDcMam1._19TLFWjMh2PdXj._2B47E_CfuRpvmD{text-align:center}._1kzPNdUsDcMam1._19TLFWjMh2PdXj>._1Qtvp02qNLbzMo{margin:0 auto}._1kzPNdUsDcMam1._2B47E_CfuRpvmD>._1Qtvp02qNLbzMo{display:inline-block;vertical-align:middle}._1Qtvp02qNLbzMo{background-image:url(" + escape(require("images/spinner.gif")) + ");background-size:30px 30px;display:block;height:30px;width:30px}._1Qtvp02qNLbzMo._36uxd9TNDw6AdD{background-size:18px 18px;height:18px;width:18px}._1Qtvp02qNLbzMo._3jNWWV-delQ9_4{margin-right:3px}", ""]);

// exports
exports.locals = {
	"wrapper": "_1kzPNdUsDcMam1",
	"centered": "_19TLFWjMh2PdXj",
	"inline": "_2B47E_CfuRpvmD",
	"spinner": "_1Qtvp02qNLbzMo",
	"small": "_36uxd9TNDw6AdD",
	"modLeft": "_3jNWWV-delQ9_4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/loading/spinner.less
// module id = Njue
// module chunks = 24